import { shouldShowClientErrorDetails } from "../../../../../../shared/frontend/feedback/clientErrorDiagnostics";
import type { ClientErrorRecoveryLabels } from "../../../../../../shared/frontend/feedback/clientErrorTypes";
import { clientErrorLabelsFor } from "../../../../../../shared/frontend/feedback/clientErrorTranslations";
import { loadAuthInfoFromStorage } from "../auth/authStorage";
import { useI18n } from "../i18n/useI18n";

export function useClientErrorRecoveryLabels(): ClientErrorRecoveryLabels {
  const { lang, tr } = useI18n();
  return clientErrorLabelsFor(lang, { backToDashboard: tr("Navigation.backToOverview") });
}

/** Stacktraces nur für Plattformadministratoren und in der Entwicklung. */
export function showClientErrorDetails(): boolean {
  return shouldShowClientErrorDetails({ role: loadAuthInfoFromStorage()?.role });
}
